"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _enotaryActions = require("../actions/enotary-actions");

var _util = require("./util");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  schedule: [//   {
    //     dayOfWeek: 'MONDAY',
    //     date: '2018-09-19T15:27:42-04:00',
    //     timeSlots: [
    //       {
    //         startTime: '15:27:42-04:00',
    //         timeSlotMinutes: 30,
    //         available: 1
    //       }
    //       ...
    //     ]
    //   }
    //   ...
  ],
  reservationsByAppId: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //    applicationUuid: 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b',
    //    reservations: [
    //      {
    //        identityUuid: '',
    //        appUuid: '',
    //        notarySessionRoomUuid: '',
    //        time: '',
    //        phoneNumber: ''
    //      }
    //      ...
    //    ]
    // }
  },
  reservation: {
    time: ''
  },
  loading: false,
  error: ''
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_enotaryActions.GET_SCHEDULE, "_").concat(_httpActions.REQUEST), "".concat(_enotaryActions.GET_RESERVATIONS, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.GET_SCHEDULE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    schedule: (0, _toConsumableArray2.default)(action.payload.days)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_enotaryActions.GET_RESERVATIONS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var applicationUuid = action.meta.applicationUuid;
  var reservationList = state.reservationsByAppId[applicationUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    reservationsByAppId: _objectSpread(_objectSpread({}, state.reservationsByAppId), {}, (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread({}, reservationList), {}, {
      applicationUuid: applicationUuid,
      reservations: (0, _util.mergeList)(reservationList.reservations, action.payload, 'time')
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_enotaryActions.CREATE_RESERVATION, "_").concat(_httpActions.REQUEST), "".concat(_enotaryActions.DELETE_RESERVATION, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_enotaryActions.CREATE_RESERVATION, "_").concat(_httpActions.FAILURE), "".concat(_enotaryActions.DELETE_RESERVATION, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, _enotaryActions.CACHE_RESERVATION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    reservation: _objectSpread(_objectSpread({}, state.reservation), {}, {
      time: action.payload.time
    }),
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, _enotaryActions.RESET_RESERVATION_CACHE, function (state) {
  // reset cache
  return _objectSpread(_objectSpread({}, state), {}, {
    reservation: {
      time: ''
    }
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;